/**
 * NIGHTBOUND - mobile bottom navigation.
 *
 * Five destinations, thumb-reachable, safe-area aware. The active tab is marked
 * with a top rule as well as colour, so the state never relies on colour alone.
 */

import { NavLink } from 'react-router-dom'
import { GAME_NAV } from '../nav'
import { cx } from './ui'

export function BottomNav() {
  return (
    <nav
      aria-label="Primary"
      className="fixed inset-x-0 bottom-0 z-30 border-t border-ash-700/50 bg-night-950/95 backdrop-blur lg:hidden"
      style={{ paddingBottom: 'var(--nb-safe-bottom)' }}
    >
      <ul className="mx-auto flex max-w-lg items-stretch">
        {GAME_NAV.map((item) => (
          <li key={item.to} className="flex-1">
            <NavLink
              to={item.to}
              className={({ isActive }) =>
                cx(
                  'relative flex flex-col items-center gap-1 py-2.5 transition-colors',
                  isActive ? 'text-ember-400' : 'text-ash-400',
                )
              }
            >
              {({ isActive }) => (
                <>
                  {isActive ? (
                    <span className="absolute inset-x-3 top-0 h-0.5 rounded-full bg-ember-500" />
                  ) : null}
                  <span aria-hidden className="relative text-lg leading-none">
                    {item.glyph}
                    {item.locked ? (
                      <span
                        aria-hidden
                        className="absolute -right-1.5 -top-1 h-1.5 w-1.5 rounded-full bg-ash-500"
                      />
                    ) : null}
                  </span>
                  <span className="nb-label text-[8.5px] leading-none">{item.short}</span>
                  {item.locked ? <span className="sr-only">Coming soon</span> : null}
                </>
              )}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  )
}
